var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":_vm.edit}},[_c('i',{staticClass:"mdi mdi-pencil"}),_vm._v(" "+_vm._s(_vm.i18n.edit)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }